import { createContext } from 'react'

const depositContext = createContext()

export default depositContext
